import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

/** Complete the master cards of jobs that were loaded from a register with no specification, from the other jobs of the
 *  same customer and product (empty fields only). Preview first; nothing already filled is touched. */
export default function FillCards() {
  const [plan, setPlan] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async (commit) => {
    setBusy(true);
    try {
      const { data } = await api.post("/jobs/fill-cards", { commit });
      setPlan(data);
      if (commit) toast.success(`${data.jobs.toLocaleString("en-IN")} master cards completed`);
    } catch (e) { toast.error(formatApiError(e)); }
    finally { setBusy(false); }
  };
  const n = (v) => Number(v || 0).toLocaleString("en-IN");
  return (
    <div className="border border-neutral-200 bg-white p-6" data-testid="fill-cards">
      <h3 className="font-display font-black text-lg tracking-tight">Complete thin master cards</h3>
      <p className="text-sm text-neutral-600 mt-1 max-w-3xl leading-relaxed">
        Jobs loaded from a register that has no specification have an almost empty Master Job Card. This fills their <b>empty fields only</b>
        (size, substrate, GSM, colours, die, ups, core and so on) from the other jobs of the <b>same customer and product</b>. Nothing already
        filled changes, and a job with no matching product is left as it is.
      </p>
      <div className="mt-3 flex items-center gap-2">
        <Button variant="outline" className="rounded-sm" disabled={busy} onClick={() => run(false)} data-testid="fill-cards-preview">{busy && !plan ? "Checking…" : "Check what would be filled"}</Button>
        {plan && !plan.committed && plan.jobs > 0 && (
          <Button className="rounded-sm bg-[#FF5A00] hover:bg-[#e04f00]" disabled={busy} onClick={() => run(true)} data-testid="fill-cards-commit">
            {busy ? "Filling…" : `Fill ${n(plan.jobs)} master cards`}
          </Button>
        )}
      </div>
      {plan && (
        <div className="mt-3 text-sm" data-testid="fill-cards-result">
          {plan.jobs === 0 ? <span className="text-emerald-700">Nothing to fill: every job that has a matching product already has its details.</span> : (
            <>
              <div>
                <b className="font-mono-num">{n(plan.jobs)}</b> jobs {plan.committed ? "completed" : "can be completed"}, <b className="font-mono-num">{n(plan.fields)}</b> empty fields {plan.committed ? "filled" : "to fill"}.
                <span className="text-neutral-500"> By BPR series: {Object.entries(plan.by_fy).map(([k, v]) => `${k.slice(0, 2)}-${k.slice(2)}: ${n(v)}`).join(" · ")}</span>
              </div>
              <div className="mt-2 text-xs text-neutral-600 space-y-0.5">
                {plan.sample.map((s) => <div key={s.bpr}><span className="font-mono-num">{s.bpr}</span> {s.customer} · {s.product} — {s.fields} fields from <span className="font-mono-num">{s.from}</span></div>)}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}
